/**
 * División político-administrativa de Colombia (DIVIPOLA · DANE).
 *
 * 32 departamentos + Bogotá D.C. con sus municipios oficiales. Los nombres
 * siguen la convención oficial del DANE (acentos, mayúsculas iniciales).
 *
 * Fuente: Marco Geoestadístico Nacional · DANE.
 * Este archivo es estático — si el DANE publica una nueva versión, hay que
 * regenerarlo. Para v1 cubre todos los municipios actuales del país.
 */

export const COLOMBIA_DIVIPOLA: Record<string, string[]> = {
  "Amazonas": [
    "Leticia",
    "El Encanto",
    "La Chorrera",
    "La Pedrera",
    "La Victoria",
    "Mirití-Paraná",
    "Puerto Alegría",
    "Puerto Arica",
    "Puerto Nariño",
    "Puerto Santander",
    "Tarapacá",
  ],
  "Antioquia": [
    "Abejorral",
    "Abriaquí",
    "Alejandría",
    "Amagá",
    "Amalfi",
    "Andes",
    "Angelópolis",
    "Angostura",
    "Anorí",
    "Anzá",
    "Apartadó",
    "Arboletes",
    "Argelia",
    "Armenia",
    "Barbosa",
    "Bello",
    "Belmira",
    "Betania",
    "Betulia",
    "Briceño",
    "Buriticá",
    "Cáceres",
    "Caicedo",
    "Caldas",
    "Campamento",
    "Cañasgordas",
    "Caracolí",
    "Caramanta",
    "Carepa",
    "Carolina del Príncipe",
    "Caucasia",
    "Chigorodó",
    "Cisneros",
    "Ciudad Bolívar",
    "Cocorná",
    "Concepción",
    "Concordia",
    "Copacabana",
    "Dabeiba",
    "Don Matías",
    "Ebéjico",
    "El Bagre",
    "El Carmen de Viboral",
    "El Peñol",
    "El Retiro",
    "El Santuario",
    "Entrerríos",
    "Envigado",
    "Fredonia",
    "Frontino",
    "Giraldo",
    "Girardota",
    "Gómez Plata",
    "Granada",
    "Guadalupe",
    "Guarne",
    "Guatapé",
    "Heliconia",
    "Hispania",
    "Itagüí",
    "Ituango",
    "Jardín",
    "Jericó",
    "La Ceja",
    "La Estrella",
    "La Pintada",
    "La Unión",
    "Liborina",
    "Maceo",
    "Marinilla",
    "Medellín",
    "Montebello",
    "Murindó",
    "Mutatá",
    "Nariño",
    "Nechí",
    "Necoclí",
    "Olaya",
    "Peque",
    "Pueblorrico",
    "Puerto Berrío",
    "Puerto Nare",
    "Puerto Triunfo",
    "Remedios",
    "Rionegro",
    "Sabanalarga",
    "Sabaneta",
    "Salgar",
    "San Andrés de Cuerquia",
    "San Carlos",
    "San Francisco",
    "San Jerónimo",
    "San José de la Montaña",
    "San Juan de Urabá",
    "San Luis",
    "San Pedro de los Milagros",
    "San Pedro de Urabá",
    "San Rafael",
    "San Roque",
    "San Vicente Ferrer",
    "Santa Bárbara",
    "Santa Fe de Antioquia",
    "Santa Rosa de Osos",
    "Santo Domingo",
    "Segovia",
    "Sonsón",
    "Sopetrán",
    "Támesis",
    "Tarazá",
    "Tarso",
    "Titiribí",
    "Toledo",
    "Turbo",
    "Uramita",
    "Urrao",
    "Valdivia",
    "Valparaíso",
    "Vegachí",
    "Venecia",
    "Vigía del Fuerte",
    "Yalí",
    "Yarumal",
    "Yolombó",
    "Yondó",
    "Zaragoza",
  ],
  "Arauca": [
    "Arauca",
    "Arauquita",
    "Cravo Norte",
    "Fortul",
    "Puerto Rondón",
    "Saravena",
    "Tame",
  ],
  "Atlántico": [
    "Barranquilla",
    "Baranoa",
    "Campo de la Cruz",
    "Candelaria",
    "Galapa",
    "Juan de Acosta",
    "Luruaco",
    "Malambo",
    "Manatí",
    "Palmar de Varela",
    "Piojó",
    "Polonuevo",
    "Ponedera",
    "Puerto Colombia",
    "Repelón",
    "Sabanagrande",
    "Sabanalarga",
    "Santa Lucía",
    "Santo Tomás",
    "Soledad",
    "Suan",
    "Tubará",
    "Usiacurí",
  ],
  "Bogotá D.C.": ["Bogotá D.C."],
  "Bolívar": [
    "Cartagena de Indias",
    "Achí",
    "Altos del Rosario",
    "Arenal",
    "Arjona",
    "Arroyohondo",
    "Barranco de Loba",
    "Calamar",
    "Cantagallo",
    "Cicuco",
    "Clemencia",
    "Córdoba",
    "El Carmen de Bolívar",
    "El Guamo",
    "El Peñón",
    "Hatillo de Loba",
    "Magangué",
    "Mahates",
    "Margarita",
    "María la Baja",
    "Mompós",
    "Montecristo",
    "Morales",
    "Norosí",
    "Pinillos",
    "Regidor",
    "Río Viejo",
    "San Cristóbal",
    "San Estanislao",
    "San Fernando",
    "San Jacinto",
    "San Jacinto del Cauca",
    "San Juan Nepomuceno",
    "San Martín de Loba",
    "San Pablo",
    "Santa Catalina",
    "Santa Rosa",
    "Santa Rosa del Sur",
    "Simití",
    "Soplaviento",
    "Talaigua Nuevo",
    "Tiquisio",
    "Turbaco",
    "Turbaná",
    "Villanueva",
    "Zambrano",
  ],
  "Boyacá": [
    "Tunja",
    "Almeida",
    "Aquitania",
    "Arcabuco",
    "Belén",
    "Berbeo",
    "Betéitiva",
    "Boavita",
    "Boyacá",
    "Briceño",
    "Buenavista",
    "Busbanzá",
    "Caldas",
    "Campohermoso",
    "Cerinza",
    "Chinavita",
    "Chiquinquirá",
    "Chíquiza",
    "Chiscas",
    "Chita",
    "Chitaraque",
    "Chivatá",
    "Chivor",
    "Ciénega",
    "Cómbita",
    "Coper",
    "Corrales",
    "Covarachía",
    "Cubará",
    "Cucaita",
    "Cuítiva",
    "Duitama",
    "El Cocuy",
    "El Espino",
    "Firavitoba",
    "Floresta",
    "Gachantivá",
    "Gámeza",
    "Garagoa",
    "Guacamayas",
    "Guateque",
    "Guayatá",
    "Güicán de la Sierra",
    "Iza",
    "Jenesano",
    "Jericó",
    "La Capilla",
    "La Uvita",
    "La Victoria",
    "Labranzagrande",
    "Macanal",
    "Maripí",
    "Miraflores",
    "Mongua",
    "Monguí",
    "Moniquirá",
    "Motavita",
    "Muzo",
    "Nobsa",
    "Nuevo Colón",
    "Oicatá",
    "Otanche",
    "Pachavita",
    "Páez",
    "Paipa",
    "Pajarito",
    "Panqueba",
    "Pauna",
    "Paya",
    "Paz de Río",
    "Pesca",
    "Pisba",
    "Puerto Boyacá",
    "Quípama",
    "Ramiriquí",
    "Ráquira",
    "Rondón",
    "Saboyá",
    "Sáchica",
    "Samacá",
    "San Eduardo",
    "San José de Pare",
    "San Luis de Gaceno",
    "San Mateo",
    "San Miguel de Sema",
    "San Pablo de Borbur",
    "Santa María",
    "Santa Rosa de Viterbo",
    "Santa Sofía",
    "Santana",
    "Sativanorte",
    "Sativasur",
    "Siachoque",
    "Soatá",
    "Socha",
    "Socotá",
    "Sogamoso",
    "Somondoco",
    "Sora",
    "Soracá",
    "Sotaquirá",
    "Susacón",
    "Sutamarchán",
    "Sutatenza",
    "Tasco",
    "Tenza",
    "Tibaná",
    "Tibasosa",
    "Tinjacá",
    "Tipacoque",
    "Toca",
    "Togüí",
    "Tópaga",
    "Tota",
    "Tununguá",
    "Turmequé",
    "Tuta",
    "Tutazá",
    "Umbita",
    "Ventaquemada",
    "Viracachá",
    "Zetaquira",
  ],
  "Caldas": [
    "Manizales",
    "Aguadas",
    "Anserma",
    "Aranzazu",
    "Belalcázar",
    "Chinchiná",
    "Filadelfia",
    "La Dorada",
    "La Merced",
    "Manzanares",
    "Marmato",
    "Marquetalia",
    "Marulanda",
    "Neira",
    "Norcasia",
    "Pácora",
    "Palestina",
    "Pensilvania",
    "Riosucio",
    "Risaralda",
    "Salamina",
    "Samaná",
    "San José",
    "Supía",
    "Victoria",
    "Villamaría",
    "Viterbo",
  ],
  "Caquetá": [
    "Florencia",
    "Albania",
    "Belén de los Andaquíes",
    "Cartagena del Chairá",
    "Curillo",
    "El Doncello",
    "El Paujil",
    "La Montañita",
    "Milán",
    "Morelia",
    "Puerto Rico",
    "San José del Fragua",
    "San Vicente del Caguán",
    "Solano",
    "Solita",
    "Valparaíso",
  ],
  "Casanare": [
    "Yopal",
    "Aguazul",
    "Chámeza",
    "Hato Corozal",
    "La Salina",
    "Maní",
    "Monterrey",
    "Nunchía",
    "Orocué",
    "Paz de Ariporo",
    "Pore",
    "Recetor",
    "Sabanalarga",
    "Sácama",
    "San Luis de Palenque",
    "Támara",
    "Tauramena",
    "Trinidad",
    "Villanueva",
  ],
  "Cauca": [
    "Popayán",
    "Almaguer",
    "Argelia",
    "Balboa",
    "Bolívar",
    "Buenos Aires",
    "Cajibío",
    "Caldono",
    "Caloto",
    "Corinto",
    "El Tambo",
    "Florencia",
    "Guachené",
    "Guapi",
    "Inzá",
    "Jambaló",
    "La Sierra",
    "La Vega",
    "López de Micay",
    "Mercaderes",
    "Miranda",
    "Morales",
    "Padilla",
    "Páez",
    "Patía",
    "Piamonte",
    "Piendamó - Tunía",
    "Puerto Tejada",
    "Puracé",
    "Rosas",
    "San Sebastián",
    "Santa Rosa",
    "Santander de Quilichao",
    "Silvia",
    "Sotará Paispamba",
    "Suárez",
    "Sucre",
    "Timbío",
    "Timbiquí",
    "Toribío",
    "Totoró",
    "Villa Rica",
  ],
  "Cesar": [
    "Valledupar",
    "Aguachica",
    "Agustín Codazzi",
    "Astrea",
    "Becerril",
    "Bosconia",
    "Chimichagua",
    "Chiriguaná",
    "Curumaní",
    "El Copey",
    "El Paso",
    "Gamarra",
    "González",
    "La Gloria",
    "La Jagua de Ibirico",
    "La Paz",
    "Manaure Balcón del Cesar",
    "Pailitas",
    "Pelaya",
    "Pueblo Bello",
    "Río de Oro",
    "San Alberto",
    "San Diego",
    "San Martín",
    "Tamalameque",
  ],
  "Chocó": [
    "Quibdó",
    "Acandí",
    "Alto Baudó",
    "Atrato",
    "Bagadó",
    "Bahía Solano",
    "Bajo Baudó",
    "Belén de Bajirá",
    "Bojayá",
    "Carmen del Darién",
    "Cértegui",
    "Condoto",
    "El Cantón del San Pablo",
    "El Carmen de Atrato",
    "El Litoral del San Juan",
    "Istmina",
    "Juradó",
    "Lloró",
    "Medio Atrato",
    "Medio Baudó",
    "Medio San Juan",
    "Nóvita",
    "Nuquí",
    "Río Iró",
    "Río Quito",
    "Riosucio",
    "San José del Palmar",
    "Sipí",
    "Tadó",
    "Unguía",
    "Unión Panamericana",
  ],
  "Córdoba": [
    "Montería",
    "Ayapel",
    "Buenavista",
    "Canalete",
    "Cereté",
    "Chimá",
    "Chinú",
    "Ciénaga de Oro",
    "Cotorra",
    "La Apartada",
    "Lorica",
    "Los Córdobas",
    "Momil",
    "Montelíbano",
    "Moñitos",
    "Planeta Rica",
    "Pueblo Nuevo",
    "Puerto Escondido",
    "Puerto Libertador",
    "Purísima de la Concepción",
    "Sahagún",
    "San Andrés de Sotavento",
    "San Antero",
    "San Bernardo del Viento",
    "San Carlos",
    "San José de Uré",
    "San Pelayo",
    "Tierralta",
    "Tuchín",
    "Valencia",
  ],
  "Cundinamarca": [
    "Agua de Dios",
    "Albán",
    "Anapoima",
    "Anolaima",
    "Apulo",
    "Arbeláez",
    "Beltrán",
    "Bituima",
    "Bojacá",
    "Cabrera",
    "Cachipay",
    "Cajicá",
    "Caparrapí",
    "Cáqueza",
    "Carmen de Carupa",
    "Chaguaní",
    "Chía",
    "Chipaque",
    "Choachí",
    "Chocontá",
    "Cogua",
    "Cota",
    "Cucunubá",
    "El Colegio",
    "El Peñón",
    "El Rosal",
    "Facatativá",
    "Fómeque",
    "Fosca",
    "Funza",
    "Fúquene",
    "Fusagasugá",
    "Gachalá",
    "Gachancipá",
    "Gachetá",
    "Gama",
    "Girardot",
    "Granada",
    "Guachetá",
    "Guaduas",
    "Guasca",
    "Guataquí",
    "Guatavita",
    "Guayabal de Síquima",
    "Guayabetal",
    "Gutiérrez",
    "Jerusalén",
    "Junín",
    "La Calera",
    "La Mesa",
    "La Palma",
    "La Peña",
    "La Vega",
    "Lenguazaque",
    "Macheta",
    "Madrid",
    "Manta",
    "Medina",
    "Mosquera",
    "Nariño",
    "Nemocón",
    "Nilo",
    "Nimaima",
    "Nocaima",
    "Pacho",
    "Paime",
    "Pandi",
    "Paratebueno",
    "Pasca",
    "Puerto Salgar",
    "Pulí",
    "Quebradanegra",
    "Quetame",
    "Quipile",
    "Ricaurte",
    "San Antonio del Tequendama",
    "San Bernardo",
    "San Cayetano",
    "San Francisco",
    "San Juan de Rioseco",
    "Sasaima",
    "Sesquilé",
    "Sibaté",
    "Silvania",
    "Simijaca",
    "Soacha",
    "Sopó",
    "Subachoque",
    "Suesca",
    "Supatá",
    "Susa",
    "Sutatausa",
    "Tabio",
    "Tausa",
    "Tena",
    "Tenjo",
    "Tibacuy",
    "Tibirita",
    "Tocaima",
    "Tocancipá",
    "Topaipí",
    "Ubalá",
    "Ubaque",
    "Ubaté",
    "Une",
    "Útica",
    "Venecia",
    "Vergara",
    "Vianí",
    "Villagómez",
    "Villapinzón",
    "Villeta",
    "Viotá",
    "Yacopí",
    "Zipacón",
    "Zipaquirá",
  ],
  "Guainía": [
    "Inírida",
    "Barrancominas",
    "Mapiripana",
    "Morichal",
    "Pana Pana",
    "Puerto Colombia",
    "San Felipe",
    "Cacahual",
    "La Guadalupe",
  ],
  "Guaviare": [
    "San José del Guaviare",
    "Calamar",
    "El Retorno",
    "Miraflores",
  ],
  "Huila": [
    "Neiva",
    "Acevedo",
    "Agrado",
    "Aipe",
    "Algeciras",
    "Altamira",
    "Baraya",
    "Campoalegre",
    "Colombia",
    "Elías",
    "Garzón",
    "Gigante",
    "Guadalupe",
    "Hobo",
    "Íquira",
    "Isnos",
    "La Argentina",
    "La Plata",
    "Nátaga",
    "Oporapa",
    "Paicol",
    "Palermo",
    "Palestina",
    "Pital",
    "Pitalito",
    "Rivera",
    "Saladoblanco",
    "San Agustín",
    "Santa María",
    "Suaza",
    "Tarqui",
    "Tello",
    "Teruel",
    "Tesalia",
    "Timaná",
    "Villavieja",
    "Yaguará",
  ],
  "La Guajira": [
    "Riohacha",
    "Albania",
    "Barrancas",
    "Dibulla",
    "Distracción",
    "El Molino",
    "Fonseca",
    "Hatonuevo",
    "La Jagua del Pilar",
    "Maicao",
    "Manaure",
    "San Juan del Cesar",
    "Uribia",
    "Urumita",
    "Villanueva",
  ],
  "Magdalena": [
    "Santa Marta",
    "Algarrobo",
    "Aracataca",
    "Ariguaní",
    "Cerro de San Antonio",
    "Chivolo",
    "Ciénaga",
    "Concordia",
    "El Banco",
    "El Piñón",
    "El Retén",
    "Fundación",
    "Guamal",
    "Nueva Granada",
    "Pedraza",
    "Pijiño del Carmen",
    "Pivijay",
    "Plato",
    "Puebloviejo",
    "Remolino",
    "Sabanas de San Ángel",
    "Salamina",
    "San Sebastián de Buenavista",
    "San Zenón",
    "Santa Ana",
    "Santa Bárbara de Pinto",
    "Sitionuevo",
    "Tenerife",
    "Zapayán",
    "Zona Bananera",
  ],
  "Meta": [
    "Villavicencio",
    "Acacías",
    "Barranca de Upía",
    "Cabuyaro",
    "Castilla la Nueva",
    "Cubarral",
    "Cumaral",
    "El Calvario",
    "El Castillo",
    "El Dorado",
    "Fuente de Oro",
    "Granada",
    "Guamal",
    "Lejanías",
    "Mapiripán",
    "Mesetas",
    "La Macarena",
    "Puerto Concordia",
    "Puerto Gaitán",
    "Puerto Lleras",
    "Puerto López",
    "Puerto Rico",
    "Restrepo",
    "San Carlos de Guaroa",
    "San Juan de Arama",
    "San Juanito",
    "San Martín",
    "Uribe",
    "Vistahermosa",
  ],
  "Nariño": [
    "Pasto",
    "Albán",
    "Aldana",
    "Ancuya",
    "Arboleda",
    "Barbacoas",
    "Belén",
    "Buesaco",
    "Chachagüí",
    "Colón",
    "Consacá",
    "Contadero",
    "Córdoba",
    "Cuaspud Carlosama",
    "Cumbal",
    "Cumbitara",
    "El Charco",
    "El Peñol",
    "El Rosario",
    "El Tablón de Gómez",
    "El Tambo",
    "Francisco Pizarro",
    "Funes",
    "Guachucal",
    "Guaitarilla",
    "Gualmatán",
    "Iles",
    "Imués",
    "Ipiales",
    "La Cruz",
    "La Florida",
    "La Llanada",
    "La Tola",
    "La Unión",
    "Leiva",
    "Linares",
    "Los Andes",
    "Magüí",
    "Mallama",
    "Mosquera",
    "Nariño",
    "Olaya Herrera",
    "Ospina",
    "Policarpa",
    "Potosí",
    "Providencia",
    "Puerres",
    "Pupiales",
    "Ricaurte",
    "Roberto Payán",
    "Samaniego",
    "San Bernardo",
    "San Lorenzo",
    "San Pablo",
    "San Pedro de Cartago",
    "Sandoná",
    "Santa Bárbara",
    "Santacruz",
    "Sapuyes",
    "Taminango",
    "Tangua",
    "Tumaco",
    "Túquerres",
    "Yacuanquer",
  ],
  "Norte de Santander": [
    "Cúcuta",
    "Ábrego",
    "Arboledas",
    "Bochalema",
    "Bucarasica",
    "Cácota",
    "Cachirá",
    "Chinácota",
    "Chitagá",
    "Convención",
    "Cucutilla",
    "Durania",
    "El Carmen",
    "El Tarra",
    "El Zulia",
    "Gramalote",
    "Hacarí",
    "Herrán",
    "La Esperanza",
    "La Playa de Belén",
    "Labateca",
    "Los Patios",
    "Lourdes",
    "Mutiscua",
    "Ocaña",
    "Pamplona",
    "Pamplonita",
    "Puerto Santander",
    "Ragonvalia",
    "Salazar de las Palmas",
    "San Calixto",
    "San Cayetano",
    "Santiago",
    "Sardinata",
    "Silos",
    "Teorama",
    "Tibú",
    "Toledo",
    "Villa Caro",
    "Villa del Rosario",
  ],
  "Putumayo": [
    "Mocoa",
    "Colón",
    "Orito",
    "Puerto Asís",
    "Puerto Caicedo",
    "Puerto Guzmán",
    "Puerto Leguízamo",
    "San Francisco",
    "San Miguel",
    "Santiago",
    "Sibundoy",
    "Valle del Guamuez",
    "Villagarzón",
  ],
  "Quindío": [
    "Armenia",
    "Buenavista",
    "Calarcá",
    "Circasia",
    "Córdoba",
    "Filandia",
    "Génova",
    "La Tebaida",
    "Montenegro",
    "Pijao",
    "Quimbaya",
    "Salento",
  ],
  "Risaralda": [
    "Pereira",
    "Apía",
    "Balboa",
    "Belén de Umbría",
    "Dosquebradas",
    "Guática",
    "La Celia",
    "La Virginia",
    "Marsella",
    "Mistrató",
    "Pueblo Rico",
    "Quinchía",
    "Santa Rosa de Cabal",
    "Santuario",
  ],
  "San Andrés y Providencia": [
    "San Andrés",
    "Providencia y Santa Catalina",
  ],
  "Santander": [
    "Bucaramanga",
    "Aguada",
    "Albania",
    "Aratoca",
    "Barbosa",
    "Barichara",
    "Barrancabermeja",
    "Betulia",
    "Bolívar",
    "Cabrera",
    "California",
    "Capitanejo",
    "Carcasí",
    "Cepitá",
    "Cerrito",
    "Charalá",
    "Charta",
    "Chima",
    "Chipatá",
    "Cimitarra",
    "Concepción",
    "Confines",
    "Contratación",
    "Coromoro",
    "Curití",
    "El Carmen de Chucurí",
    "El Guacamayo",
    "El Peñón",
    "El Playón",
    "Encino",
    "Enciso",
    "Florián",
    "Floridablanca",
    "Galán",
    "Gámbita",
    "Girón",
    "Guaca",
    "Guadalupe",
    "Guapotá",
    "Guavatá",
    "Güepsa",
    "Hato",
    "Jesús María",
    "Jordán",
    "La Belleza",
    "La Paz",
    "Landázuri",
    "Lebrija",
    "Los Santos",
    "Macaravita",
    "Málaga",
    "Matanza",
    "Mogotes",
    "Molagavita",
    "Ocamonte",
    "Oiba",
    "Onzaga",
    "Palmar",
    "Palmas del Socorro",
    "Páramo",
    "Piedecuesta",
    "Pinchote",
    "Puente Nacional",
    "Puerto Parra",
    "Puerto Wilches",
    "Rionegro",
    "Sabana de Torres",
    "San Andrés",
    "San Benito",
    "San Gil",
    "San Joaquín",
    "San José de Miranda",
    "San Miguel",
    "San Vicente de Chucurí",
    "Santa Bárbara",
    "Santa Helena del Opón",
    "Simacota",
    "Socorro",
    "Suaita",
    "Sucre",
    "Suratá",
    "Tona",
    "Valle de San José",
    "Vélez",
    "Vetas",
    "Villanueva",
    "Zapatoca",
  ],
  "Sucre": [
    "Sincelejo",
    "Buenavista",
    "Caimito",
    "Chalán",
    "Colosó",
    "Corozal",
    "Coveñas",
    "El Roble",
    "Galeras",
    "Guaranda",
    "La Unión",
    "Los Palmitos",
    "Majagual",
    "Morroa",
    "Ovejas",
    "Palmito",
    "Sampués",
    "San Antonio de Palmito",
    "San Benito Abad",
    "San Juan de Betulia",
    "San Marcos",
    "San Onofre",
    "San Pedro",
    "Santiago de Tolú",
    "Sincé",
    "Sucre",
    "Tolú Viejo",
  ],
  "Tolima": [
    "Ibagué",
    "Alpujarra",
    "Alvarado",
    "Ambalema",
    "Anzoátegui",
    "Armero",
    "Ataco",
    "Cajamarca",
    "Carmen de Apicalá",
    "Casabianca",
    "Chaparral",
    "Coello",
    "Coyaima",
    "Cunday",
    "Dolores",
    "El Espinal",
    "Falan",
    "Flandes",
    "Fresno",
    "Guamo",
    "Herveo",
    "Honda",
    "Icononzo",
    "Lérida",
    "Líbano",
    "Mariquita",
    "Melgar",
    "Murillo",
    "Natagaima",
    "Ortega",
    "Palocabildo",
    "Piedras",
    "Planadas",
    "Prado",
    "Purificación",
    "Rioblanco",
    "Roncesvalles",
    "Rovira",
    "Saldaña",
    "San Antonio",
    "San Luis",
    "Santa Isabel",
    "Suárez",
    "Valle de San Juan",
    "Venadillo",
    "Villahermosa",
    "Villarrica",
  ],
  "Valle del Cauca": [
    "Cali",
    "Alcalá",
    "Andalucía",
    "Ansermanuevo",
    "Argelia",
    "Bolívar",
    "Buenaventura",
    "Buga",
    "Bugalagrande",
    "Caicedonia",
    "Calima - El Darién",
    "Candelaria",
    "Cartago",
    "Dagua",
    "El Águila",
    "El Cairo",
    "El Cerrito",
    "El Dovio",
    "Florida",
    "Ginebra",
    "Guacarí",
    "Jamundí",
    "La Cumbre",
    "La Unión",
    "La Victoria",
    "Obando",
    "Palmira",
    "Pradera",
    "Restrepo",
    "Riofrío",
    "Roldanillo",
    "San Pedro",
    "Sevilla",
    "Toro",
    "Trujillo",
    "Tuluá",
    "Ulloa",
    "Versalles",
    "Vijes",
    "Yotoco",
    "Yumbo",
    "Zarzal",
  ],
  "Vaupés": [
    "Mitú",
    "Caruru",
    "Pacoa",
    "Papunaua",
    "Taraira",
    "Yavaraté",
  ],
  "Vichada": [
    "Puerto Carreño",
    "La Primavera",
    "Santa Rosalía",
    "Cumaribo",
  ],
};

export const DEPARTAMENTOS: ReadonlyArray<string> = Object.keys(COLOMBIA_DIVIPOLA).sort(
  (a, b) => a.localeCompare(b, "es"),
);

export function municipiosDe(departamento: string): ReadonlyArray<string> {
  return [...(COLOMBIA_DIVIPOLA[departamento] ?? [])].sort((a, b) =>
    a.localeCompare(b, "es"),
  );
}

// ============ Códigos DIVIPOLA ============
// Códigos oficiales DANE. Los 2 primeros dígitos son del departamento,
// los 3 últimos del municipio. Para v1 incluimos los 33 códigos de
// departamento + capitales + municipios donde tenemos clientes/demos.
// Los faltantes pueden ir completándose; municipiosCodigos.length crece
// sin romper nada porque divipolaCodeFor devuelve null si no encuentra.

export const DEPARTAMENTO_CODES: Record<string, string> = {
  "Amazonas": "91",
  "Antioquia": "05",
  "Arauca": "81",
  "Atlántico": "08",
  "Bogotá D.C.": "11",
  "Bolívar": "13",
  "Boyacá": "15",
  "Caldas": "17",
  "Caquetá": "18",
  "Casanare": "85",
  "Cauca": "19",
  "Cesar": "20",
  "Chocó": "27",
  "Córdoba": "23",
  "Cundinamarca": "25",
  "Guainía": "94",
  "Guaviare": "95",
  "Huila": "41",
  "La Guajira": "44",
  "Magdalena": "47",
  "Meta": "50",
  "Nariño": "52",
  "Norte de Santander": "54",
  "Putumayo": "86",
  "Quindío": "63",
  "Risaralda": "66",
  "San Andrés y Providencia": "88",
  "Santander": "68",
  "Sucre": "70",
  "Tolima": "73",
  "Valle del Cauca": "76",
  "Vaupés": "97",
  "Vichada": "99",
};

// Códigos completos por municipio. Key = "Departamento|Municipio".
// Cuando faltan, divipolaCodeFor devuelve null y el backend deja el campo
// en blanco hasta que se complete la tabla.
const MUNICIPIO_CODES: Record<string, string> = {
  // Capitales departamentales
  "Amazonas|Leticia": "91001",
  "Antioquia|Medellín": "05001",
  "Arauca|Arauca": "81001",
  "Atlántico|Barranquilla": "08001",
  "Bogotá D.C.|Bogotá D.C.": "11001",
  "Bolívar|Cartagena de Indias": "13001",
  "Boyacá|Tunja": "15001",
  "Caldas|Manizales": "17001",
  "Caquetá|Florencia": "18001",
  "Casanare|Yopal": "85001",
  "Cauca|Popayán": "19001",
  "Cesar|Valledupar": "20001",
  "Chocó|Quibdó": "27001",
  "Córdoba|Montería": "23001",
  "Guainía|Inírida": "94001",
  "Guaviare|San José del Guaviare": "95001",
  "Huila|Neiva": "41001",
  "La Guajira|Riohacha": "44001",
  "Magdalena|Santa Marta": "47001",
  "Meta|Villavicencio": "50001",
  "Nariño|Pasto": "52001",
  "Norte de Santander|Cúcuta": "54001",
  "Putumayo|Mocoa": "86001",
  "Quindío|Armenia": "63001",
  "Risaralda|Pereira": "66001",
  "San Andrés y Providencia|San Andrés": "88001",
  "Santander|Bucaramanga": "68001",
  "Sucre|Sincelejo": "70001",
  "Tolima|Ibagué": "73001",
  "Valle del Cauca|Cali": "76001",
  "Vaupés|Mitú": "97001",
  "Vichada|Puerto Carreño": "99001",

  // Cundinamarca (depto de los demos · todos los municipios)
  "Cundinamarca|Agua de Dios": "25001",
  "Cundinamarca|Albán": "25019",
  "Cundinamarca|Anapoima": "25035",
  "Cundinamarca|Anolaima": "25040",
  "Cundinamarca|Apulo": "25599",
  "Cundinamarca|Arbeláez": "25053",
  "Cundinamarca|Beltrán": "25086",
  "Cundinamarca|Bituima": "25095",
  "Cundinamarca|Bojacá": "25099",
  "Cundinamarca|Cabrera": "25120",
  "Cundinamarca|Cachipay": "25123",
  "Cundinamarca|Cajicá": "25126",
  "Cundinamarca|Caparrapí": "25148",
  "Cundinamarca|Cáqueza": "25151",
  "Cundinamarca|Carmen de Carupa": "25154",
  "Cundinamarca|Chaguaní": "25168",
  "Cundinamarca|Chía": "25175",
  "Cundinamarca|Chipaque": "25178",
  "Cundinamarca|Choachí": "25181",
  "Cundinamarca|Chocontá": "25183",
  "Cundinamarca|Cogua": "25200",
  "Cundinamarca|Cota": "25214",
  "Cundinamarca|Cucunubá": "25224",
  "Cundinamarca|El Colegio": "25245",
  "Cundinamarca|El Peñón": "25258",
  "Cundinamarca|El Rosal": "25260",
  "Cundinamarca|Facatativá": "25269",
  "Cundinamarca|Fómeque": "25279",
  "Cundinamarca|Fosca": "25281",
  "Cundinamarca|Funza": "25286",
  "Cundinamarca|Fúquene": "25288",
  "Cundinamarca|Fusagasugá": "25290",
  "Cundinamarca|Gachalá": "25293",
  "Cundinamarca|Gachancipá": "25295",
  "Cundinamarca|Gachetá": "25297",
  "Cundinamarca|Gama": "25299",
  "Cundinamarca|Girardot": "25307",
  "Cundinamarca|Granada": "25312",
  "Cundinamarca|Guachetá": "25317",
  "Cundinamarca|Guaduas": "25320",
  "Cundinamarca|Guasca": "25322",
  "Cundinamarca|Guataquí": "25324",
  "Cundinamarca|Guatavita": "25326",
  "Cundinamarca|Guayabal de Síquima": "25328",
  "Cundinamarca|Guayabetal": "25335",
  "Cundinamarca|Gutiérrez": "25339",
  "Cundinamarca|Jerusalén": "25368",
  "Cundinamarca|Junín": "25372",
  "Cundinamarca|La Calera": "25377",
  "Cundinamarca|La Mesa": "25386",
  "Cundinamarca|La Palma": "25394",
  "Cundinamarca|La Peña": "25398",
  "Cundinamarca|La Vega": "25402",
  "Cundinamarca|Lenguazaque": "25407",
  "Cundinamarca|Macheta": "25426",
  "Cundinamarca|Madrid": "25430",
  "Cundinamarca|Manta": "25436",
  "Cundinamarca|Medina": "25438",
  "Cundinamarca|Mosquera": "25473",
  "Cundinamarca|Nariño": "25483",
  "Cundinamarca|Nemocón": "25486",
  "Cundinamarca|Nilo": "25488",
  "Cundinamarca|Nimaima": "25489",
  "Cundinamarca|Nocaima": "25491",
  "Cundinamarca|Pacho": "25513",
  "Cundinamarca|Paime": "25518",
  "Cundinamarca|Pandi": "25524",
  "Cundinamarca|Paratebueno": "25530",
  "Cundinamarca|Pasca": "25535",
  "Cundinamarca|Puerto Salgar": "25572",
  "Cundinamarca|Pulí": "25580",
  "Cundinamarca|Quebradanegra": "25592",
  "Cundinamarca|Quetame": "25594",
  "Cundinamarca|Quipile": "25596",
  "Cundinamarca|Ricaurte": "25612",
  "Cundinamarca|San Antonio del Tequendama": "25645",
  "Cundinamarca|San Bernardo": "25649",
  "Cundinamarca|San Cayetano": "25653",
  "Cundinamarca|San Francisco": "25658",
  "Cundinamarca|San Juan de Rioseco": "25662",
  "Cundinamarca|Sasaima": "25718",
  "Cundinamarca|Sesquilé": "25736",
  "Cundinamarca|Sibaté": "25740",
  "Cundinamarca|Silvania": "25743",
  "Cundinamarca|Simijaca": "25745",
  "Cundinamarca|Soacha": "25754",
  "Cundinamarca|Sopó": "25758",
  "Cundinamarca|Subachoque": "25769",
  "Cundinamarca|Suesca": "25772",
  "Cundinamarca|Supatá": "25777",
  "Cundinamarca|Susa": "25779",
  "Cundinamarca|Sutatausa": "25781",
  "Cundinamarca|Tabio": "25785",
  "Cundinamarca|Tausa": "25793",
  "Cundinamarca|Tena": "25797",
  "Cundinamarca|Tenjo": "25799",
  "Cundinamarca|Tibacuy": "25805",
  "Cundinamarca|Tibirita": "25807",
  "Cundinamarca|Tocaima": "25815",
  "Cundinamarca|Tocancipá": "25817",
  "Cundinamarca|Topaipí": "25823",
  "Cundinamarca|Ubalá": "25839",
  "Cundinamarca|Ubaque": "25841",
  "Cundinamarca|Ubaté": "25843",
  "Cundinamarca|Une": "25845",
  "Cundinamarca|Útica": "25851",
  "Cundinamarca|Venecia": "25506",
  "Cundinamarca|Vergara": "25862",
  "Cundinamarca|Vianí": "25867",
  "Cundinamarca|Villagómez": "25871",
  "Cundinamarca|Villapinzón": "25873",
  "Cundinamarca|Villeta": "25875",
  "Cundinamarca|Viotá": "25878",
  "Cundinamarca|Yacopí": "25885",
  "Cundinamarca|Zipacón": "25898",
  "Cundinamarca|Zipaquirá": "25899",
};

/**
 * Devuelve el código DIVIPOLA de 5 dígitos para un par (depto, municipio).
 * Retorna null si la combinación no está mapeada todavía — el backend
 * acepta el campo en null y se puede completar después.
 */
export function divipolaCodeFor(
  departamento: string | null | undefined,
  municipio: string | null | undefined,
): string | null {
  if (!departamento || !municipio) return null;
  return MUNICIPIO_CODES[`${departamento}|${municipio}`] ?? null;
}
